<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Settlement" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <SearchSelect
                      v-model="selectedStore"
                      @selectedFullObj="selectedFullObj"
                      url="v1/get-stores"
                      :extract-options="(res) => res.data?.stores || []"
                      placeholder="Search Store..."
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Channel</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <span>From Date</span>
              <datepicker v-model="fromDate" class="form-control"/>
            </div>
            <div class="col-md-4 user_role">
              <span>To Date</span>
              <datepicker v-model="toDate" class="form-control"/>
            </div>

          </div>
          <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 user_status">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-2 btn btn-dark" @click="onClearFilters">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Settlements List</h4>
          </div>
          <div class="card-body">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" @click="tabToShow = 1">
                <a class="nav-link" :class="tabToShow == 1 ? 'active' : ''" id="home-tab" data-toggle="tab"
                   href="#home" aria-controls="home" role="tab" aria-selected="true">Aggregate</a>
              </li>
              <li class="nav-item" @click="tabToShow = 2">
                <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" id="profile-tab" data-toggle="tab"
                   href="#profile" aria-controls="profile" role="tab" aria-selected="false">Direct</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane " :class="tabToShow == 1 ? 'active' : ''" id="home" aria-labelledby="home-tab"
                   role="tabpanel">
                <CommonTable
                  url="v1/settlements"
                  :filteredData="filteredData"
                  :tableHeaderValues="tableHeaderValues"
                  :actions="actions"
                  :mutedData="mutedData"
                  customClass="table-hover-animation"
                  :exportData="exportData"
                  :hidePdfExportButton="true"
                  :tableAccordian="ReserveInfoTable"
                  :accordianCondition="accordianCondition"

                />

              </div>
              <div class="tab-pane" :class="tabToShow == 2 ? 'active' : ''" id="profile" aria-labelledby="profile-tab"
                   role="tabpanel">
                <CommonTable
                  url="v1/settlements"
                  :filteredData="filteredDirectData"
                  :tableHeaderValues="tableHeaderValues"
                  :actions="actionsDirect"
                  :mutedData="mutedData"
                  customClass="table-hover-animation"
                  :exportData="exportDataDirect"
                  :hidePdfExportButton="true"
                  :tableAccordian="ReserveInfoTable"
                  :accordianCondition="accordianCondition"

                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import SearchSelect from "@/components/common/SearchSelect.vue";
import Datepicker from 'vue3-datepicker'

export default {
  components: {SearchSelect, Datepicker},
  props: ['propFilters'],
  mounted() {
    var tabShow = 1
    if(typeof(this.$route.query.tab) != 'undefined'){
      tabShow = this.$route.query.tab
    }
    else{
      tabShow = 1
    }

    if(typeof(this.propFilters) != 'undefined'){
      let propFilters = JSON.parse(this.propFilters)

      let filterData = {}

      // if(typeof(propFilters.selectedStore) != 'undefined'){
      //   if(propFilters.selectedStore){
      //     this.selectedStore = propFilters.selectedStore
      //     filterData.storeId = this.selectedStore.id
      //   }
      // }
      //
      // if(typeof(propFilters.selectedTerminal) != 'undefined'){
      //   if(propFilters.selectedTerminal){
      //     this.selectedTerminal = propFilters.selectedTerminal
      //     filterData.terminalId = this.selectedTerminal.id
      //   }
      // }
      //
      // if(typeof(propFilters.selectedChannel) != 'undefined'){
      //   if(propFilters.selectedChannel){
      //     this.selectedChannel = propFilters.selectedChannel
      //     filterData.channelId = this.selectedChannel.id
      //   }
      // }

      if(tabShow == 1){
        filterData.type = 'aggregate'
        this.filteredData = filterData

      }else{
        filterData.type = 'direct'
        this.filteredDirectData = filterData
      }


    }

    this.tabToShow = tabShow

    this.$nextTick(() => { //with this we skip the first change
      this.notNewlyMounted = true
    })
  },

  data(){
    return{
      accordianCondition:{
        condition:(row)=>{
          if(row.rolling_reserve){
            return true
          }
          return false
        }
      },
      ReserveInfoTable: [
      {
        header: [
          {
            title: 'UUID'
          },
          {
            title: 'Reserve (Amount)'
          },
          {
            title: 'Reserve (%)'
          },
          {
            title: 'Status'
          },
          {
            title: 'Duration'
          },
          {
            title: 'Updated At'
          },
          {
            title: 'Created At'
          },

        ],
        body: {
          getData: (row) => {
            let finalData = []
            let temp = []
            if(typeof(row.rolling_reserve) != 'undefined' && row.rolling_reserve) {
              let temp = []
              temp.push(row.rolling_reserve?.uuid?row.rolling_reserve?.uuid:'N/A')
              temp.push(parseFloat(row.rolling_reserve?.amount)/100)
              temp.push(row.rolling_reserve?.rolling_reserve)
              if(row.rolling_reserve?.status == 0){
                temp.push('Pending')
              }else if(row.rolling_reserve?.status == 1){
                temp.push('Initiated')
              }
              else if(row.rolling_reserve?.status == 2){
                temp.push('Cancelled')
              }else{
                temp.push('Completed')
              }

              const {days,hours,mins} = this.convertDuration(row.rolling_reserve?.time_interval)

              let duration = days+' days '+hours+' hours '+mins+' mins'

              temp.push(duration)
              temp.push(new Date(row.rolling_reserve?.updated_at).toISOString().slice(0, 16).replace('T', ' '))
              temp.push(new Date(row.rolling_reserve?.created_at).toISOString().slice(0, 16).replace('T', ' '))

              finalData.push(temp)
            }
            return finalData
          },
          conditionalRendering:true,
          condition:(row,index)=>{
            if(row.rolling_reserve){
              return true
            }

            return false
          }
        },
      }
      ],
      notNewlyMounted:false,
      tabToShow:1,
      exportDataDirect:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlements',
            type:'direct'
          }


          if(this.selectedStore){
            requestData.storeId = this.selectedStore.id
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }
          if(this.fromDate){
            requestData.fromDate = this.formatDate(this.fromDate)
          }
          if(this.toDate){
            requestData.toDate = this.formatDate(this.toDate)
          }


          this.downloadReport(requestData)
        }
      },
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlements',
            type:'aggregate'
          }
          if(this.selectedStore){
            requestData.storeId = this.selectedStore.id
          }
          if(this.selectedTerminal){
            requestData.terminalId = this.selectedTerminal.id
          }
          if(this.selectedChannel){
            requestData.channelId = this.selectedChannel.id
          }
          if(this.fromDate){
            requestData.fromDate = this.formatDate(this.fromDate)
          }
          if(this.toDate){
            requestData.toDate = this.formatDate(this.toDate)
          }



          this.downloadReport(requestData)
        }
      },
      filteredData:{type : 'aggregate' },
      filteredDirectData:{type : 'direct' },
      breadcrumb: [
        {name: 'App'},
        {name: 'Settlement'},
        {name: 'List'},
      ],
      tableHeaderValues: [
        {
          title: 'UUID',
          valueKey: 'uuid',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-primary">${value}</span>`


            return  html


          }
        },
        {
          title: "Channel",
          valueKey: "channel",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value.name + "/" + value.code;
            }
          }
        },
        {
          title: 'Date(From)',
          valueKey: 'from_date',
        },
        {
          title: 'Date(To)',
          valueKey: 'to_date',
        },
        {
          title: 'Reference',
          valueKey: 'reference',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-primary">${value}</span>`


            return  html


          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function (value,obj){
            var html=''
            if(obj.status == 3)
              html = `<div class="badge badge-pill  badge-glow badge-success">Done</div>`
            else if(obj.status == 2)
              html = `<div class="badge badge-pill  badge-glow badge-danger">Cancelled</div>`
            else if(obj.status == 0)
              html = `<div class="badge badge-pill  badge-glow badge-warning">Pending</div>`
            else if (value == 5)
              html = `<div class="badge badge-pill  badge-glow badge-info">In Transit</div>`
            else
              html = `<div class="badge badge-pill  badge-glow badge-info">Initiated</div>`


            return html



          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</span>`


            return  html


          }
        },
        {
          title: 'Reserves',
          valueKey: 'rolling_reserve',
          html: true,
          alter: (value,row) =>  {
            var html=''
            if(value){
              html = `<div  class="font-lg-4 text-warning row justify-content-center ">${(parseFloat(value.amount / 100).toFixed(this.amountDecimalPlaces))}</div>`


              html = `
            <span class="text-center">${html}
               <div class="badge badge-light-primary mt-1">${value.rolling_reserve + '%'}</div></span>

            `
            }





            return  html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          alter: (value) => {
            return parseFloat(value / 100).toFixed(this.feesDecimalPlaces)
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</span>`


            return  html


          }
        },
        {
          title: 'Settlement Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat((parseFloat(value)-parseFloat(row.vat)-parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces)}</span>`

              if(row.rolling_reserve){
                html = `<div  class="font-lg-4 font-weight-bolder text-success">${(parseFloat((parseFloat(value)-parseFloat(row.vat)-parseFloat(row.fee)-parseFloat(row.rolling_reserve.amount)) / 100).toFixed(this.amountDecimalPlaces))}</div>`
              }

            return  html


          }
        },
        {
          title: "Settlement Type",
          valueKey: "channel",
          html: true,
          alter: function(value, row) {
            // Settlement is either for a store or for a channel
            // Prefix is highlighted, the name follows it in the same badge
            let label = '-';
            if (row.store && row.store.name) {
              label = `<strong class="text-danger">Store:</strong> ${row.store.name}`;
            } else if (value && value.name) {
              label = `<strong class="text-danger">Channel:</strong> ${value.name}`;
            }
            let html = `<p class="badge badge-light-primary">${label}</p>`;
            if (row.payment_methods && row.payment_methods.length > 0) {
              const paymentMethod = row.payment_methods.find(pm => pm.pivot && pm.pivot.status === 1);
              if (paymentMethod) {
                html = `
                  <div class="row">
                      <div class="col-12">
                         ${html}
                          <div class="badge badge-light-warning">${paymentMethod.name}</div>
                      </div>
                  </div>
                  `;
              }
            }
            return html;
          }
        },
        {
          title: 'Account',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-light-success">${value}</a>`

            return html


          }
        },
        {
          title: 'Time/Date',
          valueKey: 'created_at',
         alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: 'Settlement Transactions',
          class: 'btn-primary badge badge-primary',
          cta: (row, index) => {
            this.$store.commit('setSetSettlementData',row)
            let propFilters = this.filteredData
            this.$router.push({name: 'agregate-settlement-detail',params: {id:row.id,propFilters: JSON.stringify(propFilters)}})
          },

        },
      ],
      actionsDirect:[
        {
          title: 'Settlement Transactions',
          class: 'btn-primary badge badge-primary',
          cta: (row, index) => {
            this.$store.commit('setSetSettlementData',row)
            let propFilters = this.filteredDirectData
            this.$router.push({name: 'direct-settlement-detail',params: {id:row.id,propFilters: JSON.stringify(propFilters)}})
          },

        },
      ],
      mutedData: [],
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      fromDate: null,
      toDate: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    }
  },
  methods:{
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    selectedFullObj(obj){
      if(obj){
        this.terminalData = obj.terminals
      }else{
        this.terminalData = []
      }
    },
    onSubmitFilters() {
      let dataFiltered = {}

      if(this.selectedStore){
        dataFiltered.selectedStore = this.selectedStore
        dataFiltered.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        dataFiltered.selectedTerminal = this.selectedTerminal
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.selectedChannel = this.selectedChannel
        dataFiltered.channelId = this.selectedChannel.id
      }
      if(this.fromDate){
        dataFiltered.fromDate = this.formatDate(this.fromDate)
      }
      if(this.toDate){
        dataFiltered.toDate = this.formatDate(this.toDate)
      }

      if(this.tabToShow == 1){

        dataFiltered.type = 'aggregate'
        this.filteredData = dataFiltered

      }else{
        dataFiltered.type = 'direct'
        this.filteredDirectData = dataFiltered
      }



    },
    onClearFilters() {

      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.fromDate = null
      this.toDate = null
      this.filteredData = {type : 'aggregate'}
      this.filteredDirectData = {type : 'direct'}


    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      if(this.notNewlyMounted){
        this.selectedChannel = null
      }
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>

